@if (onMobile$ | async) {
  <rk-mobile-close-button class="fixed z-10" (click)="onAbort()"></rk-mobile-close-button>
  <div class="p-5 pt-6">
    <ng-template *ngTemplateOutlet="content"></ng-template>
    <rk-footer-actions
      [inline]="true"
      [submitText]="
        'MEDIA.MODAL.PLAYLIST.ADD_DUPLICATE.DONT_ADD' | translate: { tracks: 1 }
      "
      [cancelText]="
        'MEDIA.MODAL.PLAYLIST.ADD_DUPLICATE.ADD_ANYWAY' | translate: { tracks: 1 }
      "
      (submitted)="addDuplicatesMode('skip')"
      (cancelled)="addDuplicatesMode('all')"
    ></rk-footer-actions>
  </div>
} @else {
  <rk-modal-wrapper
    (submitted)="addDuplicatesMode('skip')"
    (cancelled)="addDuplicatesMode('all')"
    (closed)="onAbort()"
    [title]="
      'MEDIA.MODAL.PLAYLIST.ADD_DUPLICATE.TITLE'
        | translate: { tracks: dataIn.isSingle ? 1 : 2 }
    "
    [submitText]="
      'MEDIA.MODAL.PLAYLIST.ADD_DUPLICATE.DONT_ADD'
        | translate: { tracks: dataIn.isSingle ? 1 : 2 }
    "
    [cancelText]="
      'MEDIA.MODAL.PLAYLIST.ADD_DUPLICATE.ADD_ANYWAY'
        | translate: { tracks: dataIn.isSingle ? 1 : 2 }
    "
    [loading]="isLoading$ | async"
  >
    <ng-template *ngTemplateOutlet="content"></ng-template>
  </rk-modal-wrapper>
}

<ng-template #content>
  <div
    *ngIf="dataIn.isSingle; else multiple"
    class="content-duplicate-track"
    [innerHTML]="
      'MEDIA.MODAL.PLAYLIST.ADD_DUPLICATE.CONTENT_SINGLE'
        | translate: { name: getEllipsisTitle() }
    "
  ></div>
</ng-template>

<ng-template #multiple>
  <div
    class="content-move-track"
    [innerHTML]="'MEDIA.MODAL.PLAYLIST.ADD_DUPLICATE.CONTENT_MULTIPLE' | translate"
  ></div>
</ng-template>
